import * as types from '../constants/actionTypes';
import tellUsAboutYourselfService from '../services/tellUsAboutYourselfService';

export function loadSexDataSuccess(data) {
  return { type: types.TU1_LOAD_SEX_SUCCESS, data };
}

export function loadAgeDataSuccess(data) {
  return { type: types.TU1_LOAD_AGE_SUCCESS, data };
}

export function loadEthnicityDataSuccess(data) {
  return { type: types.TU1_LOAD_ETHNICITY_SUCCESS, data };
}
export function loadRelationShipSuccess(data) {
  return { type: types.TU1_LOAD_RELATION_SHIP_SUCCESS, data };
}
export function loadBodyTypesDataSuccess(data) {
  return { type: types.LOAD_BODY_TYPES_DATA_SUCCESS, data };
}

export function loadHeightDataSuccess(data) {
  return { type: types.LOAD_HEIGHT_DATA_SUCCESS, data };
}

export function loadOrientationDataSuccess(data) {
  return { type: types.LOAD_ORIENTATION_DATA_SUCCESS, data };
}

export function updateAgeSuccess(data) {
  return { type: types.TU1_UPDATE_AGE_SUCCESS, data };
}

export function updateHeightSuccess(data) {
  return { type: types.TU1_UPDATE_HEIGHT_SUCCESS, data };
}

export function loadSexTellUsAboutYourSelfData(params) {
  return dispatch => {
    return tellUsAboutYourselfService.loadSexTellUsAboutYourSelfData(params).then(res => {
      if (res.success) {
        dispatch(loadSexDataSuccess({ items: res.data.items, init: params }));
      }
      return res;
    });
  };
}

export function loadAgeTellUsAboutYourSelfData(params) {
  return dispatch => {
    dispatch(loadAgeDataSuccess(params));
  };
}

export function loadEthnicityTellUsAboutYourSelfData(params) {
  return dispatch => {
    return tellUsAboutYourselfService.loadEthnicityTellUsAboutYourSelfData(params).then(res => {
      if (res.success) {
        dispatch(loadEthnicityDataSuccess({ items: res.data.items, init: params }));
      }
      return res;
    });
  };
}
export function loadRelationShip(params) {
  return dispatch => {
    return tellUsAboutYourselfService.loadRelationShip().then(res => {
      if (res.success) {
        dispatch(loadRelationShipSuccess({ items: res.data.items, init: params }));
      }
      return res;
    });
  };
}

export function loadBodyTypesData(params, memberType) {
  return dispatch => {
    return tellUsAboutYourselfService.loadBodyTypesData(params, memberType).then(res => {
      if (res.success) {
        dispatch(loadBodyTypesDataSuccess({ items: res.data.items, init: params }));
      }
      return res;
    });
  };
}

export function loadHeightData(params) {
  return dispatch => {
    return tellUsAboutYourselfService.loadHeightData(params).then(res => {
      if (res.success) {
        dispatch(loadHeightDataSuccess({ items: res.data.items, init: params }));
      }
      return res;
    });
  };
}

export function loadOrientationData(params, memberType) {
  return dispatch => {
    return tellUsAboutYourselfService.loadOrientationData(params, memberType).then(res => {
      if (res.success) {
        dispatch(loadOrientationDataSuccess({ items: res.data.items, init: params }));
      }
      return res;
    });
  };
}

export function updateAge(params) {
  return dispatch => {
    dispatch(updateAgeSuccess(params));
  };
}

export function updateHeight(params) {
  return dispatch => {
    dispatch(updateHeightSuccess(params));
  };
}
